import React, { Fragment, useState, useEffect } from "react";
import { Breadcrumbs, Btn } from "../../AbstractElements";
import axios from "axios";
import { Link } from "react-router-dom";
import { FaPencilAlt, FaRegTrashAlt } from "react-icons/fa";
import { TopCenter, directiontoaster } from "../../Constant";
import { toast } from "react-toastify";
import "./styles.css";

import {
	Row,
	Col,
	Card,
	Form,
	Label,
	Input,
	CardHeader,
	CardBody,
	Table,
	Container,
} from "reactstrap";

const CandidateSkills = (e) => {
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const API_BASE_URL = window.appConfig.API_BASE_URL;

	let handleSubmit = async (e) => {
		e.preventDefault();
		try {
			let res = await axios.post(
				`${API_BASE_URL}/Skills/AddSkill`,
				{
					name: name,
				},
				{ headers: { "Content-Type": "application/json" } }
			);
			if (res.status === 200) {
				setName("");
			}
			// return directiontoaster("directionssuccessToast");
			//modal
			window.location.href = "/skills";
		} catch (err) {
			return directiontoaster("directionsdangerToast");
		}
	};

	const deleteHandler = async (id, item) => {
		const confirmed = window.confirm(
			`Are you sure you would like to delete ${item}`
		);
		try {
			if (confirmed) {
				const response = await axios.delete(`${API_BASE_URL}/Skills/${id}`);
			}
			window.location.href = "/viho/skills";
		} catch (error) {
			console.error("Something went wrong", error);
		}
	};

	const directiontoaster = (toastname) => {
		switch (toastname) {
			case "directionssuccessToast":
				toast.success("The skill was successfully added", {
					position: toast.POSITION.TOP_CENTER,
				});
				break;
			case "directionsdangerToast":
				toast.error("There was an error adding the skill", {
					position: toast.POSITION.TOP_CENTER,
				});
				break;
		}
	};

	const [data, setDate] = useState([]);
	const [error, setError] = useState({ error: false, message: "" });

	useEffect(() => {
		let isMounted = true;
		axios
			.get(`${API_BASE_URL}/Skills`)
			.then((res) => {
				if (isMounted) {
					const skillList = res.data;
					setDate(skillList);
				}
			})
			.catch((err) => {
				console.error(err);
			});
		return () => {
			isMounted = false;
		};
	}, []);

	return (
		<Fragment>
			<Breadcrumbs parent="Master Data" title="Skills" mainTitle="Skills" />
			<Container fluid={true}>
				<Card>
					<CardHeader className="pb-0"></CardHeader>
					<CardBody>
						<Form onSubmit={handleSubmit}>
							<Row className="g-3">
								<Col md="4">
									<Label className="form-label" for="validationCustom01">
										Name
									</Label>
									<Input
										type="text"
										name="name"
										required={true}
										className="form-control"
										onChange={(e) => setName(e.target.value)}
									/>
								</Col>
								<Row className="g-3">
									<Col md="4">
										<Btn type="submit" attrBtn={{ color: "primary" }}>
											{"Add Skill"}
										</Btn>
									</Col>
								</Row>
							</Row>
						</Form>
					</CardBody>
					<br></br>
					<Table>
						<thead>
							<tr className="mustHaveRow">
								<th className="mustHaveHeaders">Name</th>
								<th className="mustHaveHeaders-icons"></th>
							</tr>
						</thead>
						<tbody>
							{data.map(({ name, skillId }) => {
								return (
									<tr key={name} className="mustHaveRow">
										<td className="row-item">{name}</td>
										<td className="row-item-icons">
											<Link to={`/editskill/:${skillId}`}>
												<i className="icon" title="Edit Candidate">
													<FaPencilAlt />
												</i>
											</Link>
											<i
												onClick={(e) => deleteHandler(skillId, name)}
												title="Delete Must Have"
												className="icon"
												id="del-icon"
											>
												<FaRegTrashAlt />
											</i>
										</td>
									</tr>
								);
							})}
						</tbody>
					</Table>
				</Card>
			</Container>
		</Fragment>
	);
};

export default CandidateSkills;
